import {
  FileExcelOutlined,
  FileImageOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileTextOutlined,
  FileWordOutlined,
} from '@ant-design/icons'

import cn from './getFileIcon.module.scss'

export const getFileIcon = (extension: string) => {
  const ext = extension.toLowerCase()

  switch (ext) {
    case 'pdf':
      return <FilePdfOutlined className={cn.pdf} />
    case 'doc':
    case 'docx':
      return <FileWordOutlined className={cn.word} />
    case 'xls':
    case 'xlsx':
    case 'xlsm':
      return <FileExcelOutlined className={cn.excel} />
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'webp':
    case 'jfif':
      return <FileImageOutlined className={cn.image} />
    case 'pptx':
      return <FilePptOutlined className={cn.presentation} />
    default:
      return <FileTextOutlined className={cn.other} />
  }
}
